module.exports = __webpack_public_path__ + "img/promotion_price.ee1b5160.png";